import React, { FC, PropsWithChildren, useRef } from "react";
import styled from "styled-components";
import Input from "./Input";
import { CheckMark } from "./Checkmark";
import AirbnbResults from "./Icons/AirbnbResults";
import HotelResults from "./Icons/HotelResults";
import StoreResults from "./Icons/StoreResults";
import RadioInput from "./RadioInput";

// Importing the store icons

interface IFilterFormGroup {
  checked: boolean;
  onClick: (e: InputEvent) => void;
  value: string;
  label: string;
  keyName: any;
  attributeVal?: string;
  type?: string;
  filterType?: string;
  gridColumnStyle?: string;
}

const FilterFormGroup = styled.div`
  margin: 0.2rem 0;
`;

const CheckedFilterInputLabel = styled.label`
  font-size: 13px;
  text-transform: capitalize;
  padding-top: 1px;
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: left;
  align-content: flex-start;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.3;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0.2rem 0.5rem;
`;
const FilterInputLabel = styled.label`
  font-size: 13px;
  text-transform: capitalize;
  padding-top: 1px;
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: left;
  align-content: flex-start;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.3;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0.2rem 0.5rem;
`;

const GridContainer = styled.div<{ filterType?: string }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.filterType === "business" ? `7rem 2rem` : `1fr`};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const FilterItem: FC<PropsWithChildren<IFilterFormGroup>> = ({
  checked,
  onClick,
  value,
  label,
  keyName,
  type,
  filterType,
  gridColumnStyle,
}) => {
  const GridContainerRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  return (
    <FilterFormGroup key={keyName}>
      {checked ? (
        <CheckedFilterInputLabel>
          {type == "radio" ? (
            <>
              <RadioInput
                checked={checked}
                handleClick={onClick}
                value={value}
              />
            </>
          ) : (
            <Input checked={checked} handleClick={onClick} value={value} />
          )}
          <CheckMark />
          <GridContainer ref={GridContainerRef} filterType={filterType}>
            {label}

            {/* Start of business type icon section */}
            {value == "airbnb" ? (
              <IconWrapper>
                <AirbnbResults />
              </IconWrapper>
            ) : null}

            {value == "store" ? (
              <IconWrapper>
                <StoreResults />
              </IconWrapper>
            ) : null}

            {value == "hotel" ? (
              <IconWrapper>
                <HotelResults />
              </IconWrapper>
            ) : null}
          </GridContainer>
        </CheckedFilterInputLabel>
      ) : (
        <FilterInputLabel>
          {type == "radio" ? (
            <RadioInput checked={checked} handleClick={onClick} value={value} />
          ) : (
            <Input checked={checked} handleClick={onClick} value={value} />
          )}
          <CheckMark />
          <GridContainer ref={GridContainerRef} filterType={filterType}>
            {label}
            {/* Start of business type icon section */}
            {value == "airbnb" ? (
              <IconWrapper>
                <AirbnbResults />
              </IconWrapper>
            ) : null}
            {value == "store" ? (
              <IconWrapper>
                <StoreResults />
              </IconWrapper>
            ) : null}
            {value == "hotel" ? (
              <IconWrapper>
                <HotelResults />
              </IconWrapper>
            ) : null}{" "}
          </GridContainer>
        </FilterInputLabel>
      )}
    </FilterFormGroup>
  );
};
